module.exports = __webpack_public_path__ + "app stores2.svg?bb70eac03776281b114eea69473b2202";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/app stores2.svg
// module id = 19
// module chunks = 0